import { render, staticRenderFns } from "./Drawprizesimgs.vue?vue&type=template&id=71852dcd&scoped=true&"
import script from "./Drawprizesimgs.vue?vue&type=script&lang=js&"
export * from "./Drawprizesimgs.vue?vue&type=script&lang=js&"
import style0 from "./Drawprizesimgs.vue?vue&type=style&index=0&id=71852dcd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71852dcd",
  null
  
)

export default component.exports